export * from './src/search.results.data.view.widget'